import React, { Component } from 'react'
import Modal from 'react-modal'

const customStyles = {
	overlay : {
		zIndex			: '99999',
		backgroundColor	: 'rgba(0,0,0,0.6)'
	},
	content : {
		position	: 'fixed',
		top			: '50%',
		left		: '50%',
		right		: 'auto',
		bottom		: 'auto',
		transform	: 'translate(-50%, -50%)',
		outline		: '0'
	}
}

Modal.setAppElement('#root')

class ModalEventSession extends Component {
  render() {
    const {
      isOpen,
      titleText,
      mainText,
      htmlContent,
      action,
      onConfirm,
      onYes,
      onNo,
      onClose,
      className,
      closeTimeoutMS = 300,
    } = this.props

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        style={customStyles}
        className={'obj_popin ' + (className || '')}
        closeTimeoutMS={closeTimeoutMS}
        contentLabel="Modal"
      >
        <button className="bt_close" onClick={onClose} aria-label="Fermer la modale" />
        <div className="ctn_popin">
          {titleText && <p className="t_title">{titleText}</p>}
          {mainText && <p className="t_main">{mainText}</p>}
          {htmlContent}

          {action === 'close' && (
            <div className="ctn_cta">
              <button className="obj_cta" type="button" onClick={onClose}>
                Fermer
              </button>
            </div>
          )}

          {action === 'confirm' && (
            <div className="ctn_cta">
              <button className="obj_cta" type="button" onClick={onConfirm}>
                Confirmer
              </button>
            </div>
          )}

          {action === 'yesno' && (
            <div className="ctn_cta">
              <button className="obj_cta" type="button" onClick={onYes}>
                Oui
              </button>
              <button className="obj_cta obj_cta_secondary" type="button" onClick={onNo}>
                Non
              </button>
            </div>
          )}
        </div>
      </Modal>
    )
  }
}

export default ModalEventSession
